export default Buffer.from("A+BSQ29weXJpZ2h0IDE5OTAtMjAwOSBBZG9iZSBTeXN0ZW1zIEluY29ycG9yYXRlZC4KQWxsIHJpZ2h0cyByZXNlcnZlZC4KU2VlIC4vTElDRU5TReENVW5pQ05TLVVDUzItSGENIBMAeAAAehAAbZ9iAYEWAAGBEgABgRoAAYEeAAGBDgIBgQqDnDkA6zGBOAGBAlEAgQYBAIEH", "base64")


//////////////////
// WEBPACK FOOTER
// ./~/vue-pdf-signature/src/buffer-loader.js!./~/pdfjs-dist-sign/cmaps/UniCNS-UCS2-V.bcmap
// module id = 687
// module chunks = 502